export const PAGE_SIZE = 20;

export type PaymentsTab = "payments" | "payouts";

export const TABS: { key: PaymentsTab; label: string }[] = [
    { key: "payments", label: "Платежи" },
    { key: "payouts", label: "Выплаты" },
];
